import { useEffect, useRef } from "react";

const chartHeight = 10;

function ValuesBar( { stat }) {
  const canvasRef = useRef(null);
  const ref = useRef(null);

  // Resolve DaisyUI theme colors via a temporary DOM element so we always get
  // rgb() values — canvas fillStyle and html2canvas both need rgb, not oklch.
  const getThemeColor = (cls) => {
    const tmp = document.createElement("div");
    tmp.style.cssText = "position:fixed;opacity:0;pointer-events:none;width:1px;height:1px";
    tmp.className = cls;
    document.body.appendChild(tmp);
    const color = window.getComputedStyle(tmp).backgroundColor;
    document.body.removeChild(tmp);
    return color || "rgb(100,100,200)";
  };
  const primaryColor = getThemeColor("bg-primary");
  const secondaryColor = getThemeColor("bg-secondary");


  const draw = (ctx, logicalW, logicalH) => {
    const midx = logicalW / 2;
    ctx.fillStyle = "#eeeeee";
    ctx.fillRect(0, 0, logicalW, logicalH);
    const max = stat.isPercent ? 100 : Math.max(stat.value1, stat.value2);
    const scalex = midx / max;
    ctx.fillStyle = primaryColor;
    ctx.fillRect(midx - stat.value1 * scalex, 0, stat.value1 * scalex, logicalH);
    ctx.fillStyle = secondaryColor;
    ctx.fillRect(midx, 0, stat.value2 * scalex, logicalH);
  };

  const redraw = () => {
    const canvas = canvasRef.current;
    const container = ref.current;
    if (!canvas || !container) return;
    const dpi = window.devicePixelRatio || 1;
    const logicalW = container.offsetWidth;
    const logicalH = chartHeight;
    canvas.width = logicalW * dpi;
    canvas.height = logicalH * dpi;
    canvas.style.width = logicalW + "px";
    canvas.style.height = logicalH + "px";
    const context = canvas.getContext("2d");
    context.scale(dpi, dpi);
    draw(context, logicalW, logicalH);
  };

  useEffect(() => {
    redraw();
    const ro = new ResizeObserver(() => redraw());
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stat]);

  const onMouseDown = (_e) => {
  }

  return (
    <>
      <div ref={ref} className="w-full">
        <canvas id="canvas" ref={canvasRef} onMouseDown={onMouseDown} />
      </div>
    </>
  );
}

export default ValuesBar;
